import { Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './MealHeader.styled';
interface MealHeaderProps {
    name?: string;
    difficulty?: string;
    cookingTime?: number;
    copy: { description: string };
}

export const MealHeader = ({ name, difficulty, cookingTime, copy }: MealHeaderProps) => (
    <section>
        <Text type="option-title-large-text" medium>
            {name}
        </Text>
        <Text type="small-text" mt={4}>
            {cookingTime} {copy.description} <S.Difficulty>{difficulty}</S.Difficulty>
        </Text>
    </section>
);
